export default __webpack_public_path__ + "static/media/placeholder-date.87b52266.svg";